import { MS_API_BACKEND_URL } from "../settings";
import { api } from "./api";

class PurchaseRequestService {
  constructor() {
    this.url = MS_API_BACKEND_URL;
    this.basePath = `${this.url}/api/purchase-supply/v1/purchase-request`;
  }

  async getAll(params) {
    const { data } = await api.get(this.basePath, { params });
    return {
      data: {
        results: data?.results || [],
        total_count:
          data?.total_count ??
          data?.totalCount ??
          data?.count ??
          (data?.results ? data.results.length : 0)
      }
    };
  }

  async create(payload) {
    return await api.post(this.basePath, payload);
  }

  async update(id, payload) {
    return await api.patch(`${this.basePath}/${id}`, payload);
  }

  async remove(id) {
    return await api.delete(`${this.basePath}/${id}`);
  }

  async importFromExcel(file, requestDate) {
    const formData = new FormData();
    formData.append("file", file);

    return await api.post(`${this.basePath}/import`, formData, {
      params: { request_date: requestDate },
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
}

const purchaseRequestService = new PurchaseRequestService();
export default purchaseRequestService;
